<template>
  <div class="weui-flex">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'Flex',
  data() {
    return {}
  }
}
</script>




// WEBPACK FOOTER //
// src/components/flex/flex.vue